import React               from 'react'
import PropTypes           from 'prop-types'
import { Link            } from 'react-router-dom'
import { Row, Col, Alert } from 'react-bootstrap'
import classNames          from 'classnames'

import { withAuthContext                          } from 'alto-react-base-auth/lib/components'
import { generalProfileSetting, tradeTermsSetting } from 'alto-react-client-auth/lib/settings'
import { ContactFormLink                          } from 'alto-react-client-auth/lib/routes'
import { IfContactFormEnabled                     } from 'alto-react-client-auth/lib/components'

import ProfilePanel        from './profile_panel'
import ChangePasswordPanel from './change_password_panel'

export default class Profile extends React.Component
  @contextTypes =
    auth:     PropTypes.object
    settings: PropTypes.object

  @changePasswordPanelComponent: ChangePasswordPanel

  constructor: (props, context) ->
    super(props, context)

    @profileSetting    = generalProfileSetting(context.settings)
    @tradeTermsSetting = tradeTermsSetting(context.settings)

  render: ->
    ChangePasswordPanelComponent = @constructor.changePasswordPanelComponent

    if @enableFullProfile()
      <Row>
        <Col xs={12} sm={6}>
          <ProfilePanel />
        </Col>
        <Col xs={12} sm={6}>
          <ChangePasswordPanelComponent client={true} />
          {@info()}
        </Col>
      </Row>
    else
      <Row>
        <Col xs={12}>
          <ChangePasswordPanelComponent client={false} />
        </Col>
      </Row>

  enableFullProfile: ->
    @profileSetting.enabled and @context.auth.isClient

  info: ->
    <Alert className={classNames('auth-alert right', client: @context.auth.isClient)}>
      {@tradeTerms()}

      <IfContactFormEnabled>
        {@contactInfo()}
      </IfContactFormEnabled>
    </Alert>

  contactInfo: ->
    <p>
      Narazili jste na problém s naší aplikací?&ensp;
      <ContactFormLink>Kontaktujte nás</ContactFormLink>
    </p>

  tradeTerms: ->
    if @tradeTermsSetting.show and @tradeTermsSetting.linkUrl
      <p>
        Obchodní podmínky k nahlédnutí&nbsp;
        <a href={@tradeTermsSetting.linkUrl} target="_blank">zde</a>
      </p>
